function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M74.254 50.488A23.904 23.904 0 0057.49 57.49a23.904 23.904 0 000 33.805L222.195 256 57.49 420.705a23.904 23.904 0 000 33.805 23.904 23.904 0 0033.805 0L256 289.805 420.705 454.51a23.904 23.904 0 0033.805 0 23.904 23.904 0 000-33.805L289.805 256 454.51 91.295a23.904 23.904 0 000-33.805 23.904 23.904 0 00-17.04-7.002 23.904 23.904 0 00-16.765 7.002L256 222.195 91.295 57.49a23.904 23.904 0 00-17.041-7.002z",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    color: "#000",
    fontWeight: 400,
    fontFamily: "sans-serif",
    overflow: "visible",
    fill: "#f8f8f8"
  }));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBkPSJNNzQuMjU0IDUwLjQ4OEEyMy45MDQgMjMuOTA0IDAgMDA1Ny40OSA1Ny40OWEyMy45MDQgMjMuOTA0IDAgMDAwIDMzLjgwNUwyMjIuMTk1IDI1NiA1Ny40OSA0MjAuNzA1YTIzLjkwNCAyMy45MDQgMCAwMDAgMzMuODA1IDIzLjkwNCAyMy45MDQgMCAwMDMzLjgwNSAwTDI1NiAyODkuODA1IDQyMC43MDUgNDU0LjUxYTIzLjkwNCAyMy45MDQgMCAwMDMzLjgwNSAwIDIzLjkwNCAyMy45MDQgMCAwMDAtMzMuODA1TDI4OS44MDUgMjU2IDQ1NC41MSA5MS4yOTVhMjMuOTA0IDIzLjkwNCAwIDAwMC0zMy44MDUgMjMuOTA0IDIzLjkwNCAwIDAwLTE3LjA0LTcuMDAyIDIzLjkwNCAyMy45MDQgMCAwMC0xNi43NjUgNy4wMDJMMjU2IDIyMi4xOTUgOTEuMjk1IDU3LjQ5YTIzLjkwNCAyMy45MDQgMCAwMC0xNy4wNDEtNy4wMDJ6IiBzdHlsZT0ibGluZS1oZWlnaHQ6bm9ybWFsO2ZvbnQtdmFyaWFudC1saWdhdHVyZXM6bm9ybWFsO2ZvbnQtdmFyaWFudC1wb3NpdGlvbjpub3JtYWw7Zm9udC12YXJpYW50LWNhcHM6bm9ybWFsO2ZvbnQtdmFyaWFudC1udW1lcmljOm5vcm1hbDtmb250LXZhcmlhbnQtYWx0ZXJuYXRlczpub3JtYWw7Zm9udC12YXJpYW50LWVhc3QtYXNpYW46bm9ybWFsO2ZvbnQtZmVhdHVyZS1zZXR0aW5nczpub3JtYWw7Zm9udC12YXJpYXRpb24tc2V0dGluZ3M6bm9ybWFsO3RleHQtaW5kZW50OjA7dGV4dC1hbGlnbjpzdGFydDt0ZXh0LWRlY29yYXRpb24tbGluZTpub25lO3RleHQtZGVjb3JhdGlvbi1zdHlsZTpzb2xpZDt0ZXh0LWRlY29yYXRpb24tY29sb3I6IzAwMDt0ZXh0LXRyYW5zZm9ybTpub25lO3RleHQtb3JpZW50YXRpb246bWl4ZWQ7d2hpdGUtc3BhY2U6bm9ybWFsO3NoYXBlLXBhZGRpbmc6MDtzaGFwZS1tYXJnaW46MDtpbmxpbmUtc2l6ZTowO2lzb2xhdGlvbjphdXRvO21peC1ibGVuZC1tb2RlOm5vcm1hbDtzb2xpZC1jb2xvcjojMDAwO3NvbGlkLW9wYWNpdHk6MSIgY29sb3I9IiMwMDAiIGZvbnQtd2VpZ2h0PSI0MDAiIGZvbnQtZmFtaWx5PSJzYW5zLXNlcmlmIiBvdmVyZmxvdz0idmlzaWJsZSIgZmlsbD0iI2Y4ZjhmOCIvPjwvc3ZnPg==";
export { SvgIconClose as ReactComponent };